import BarValues from './bar-values.component';
export default BarValues;
